import { Heading, Paragraph } from "@/components/ui/Typography";
import { sanitizeHtml } from "@/utils/helpers/html";


const NewsItem = ({data, brandData}:{data: {
    newsFeedSectionTitle?: string | null;
  newsFeedSectionDescription?: string | null;
  newsFeedSectionImageUrl?: string | null;
}, brandData: {
  websiteColorCode?: string | null;
}}) => {

  const PreviewComponent = () => {
    return (
      <div className="grid relative gap-4 w-full justify-center">   


<div style={{backgroundColor: brandData?.websiteColorCode ?? ""}} className="h-2 w-1/2 my-2 rounded">

</div>
      <div>
         <img src={data?.newsFeedSectionImageUrl ? data?.newsFeedSectionImageUrl : "/blank-image-placeholder.png"} alt={data?.newsFeedSectionTitle ?? ""} className="max-h-96 h-full w-full object-cover object-center rounded" />
      </div>
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-3">
           <Heading level={4}>{data?.newsFeedSectionTitle}</Heading>
          </div>
         
          <Paragraph dangerouslySetInnerHTML={{ __html: sanitizeHtml(data?.newsFeedSectionDescription ?? "") }} ></Paragraph>
      </div>
      </div>
    )
  };


  return (
    <div>
       <PreviewComponent />
    </div>
  )
}

export default NewsItem